import {useMutation} from "@tanstack/react-query";

import {updateSupplierOfferMutationOptions} from "./update-supplier-offer.mutation-options";

export function useUpdateSupplierOffer(supplierId: string, catalogItemId: string) {
  return useMutation(updateSupplierOfferMutationOptions(supplierId, catalogItemId));
}
